<script>
export default {
  props: ["value", "data", "size"],
  data() {
    return {
      stockOnly: false,
      filterBy: [],
      filters: [],
      prices: [
        { min: 0, max: 10, cnt: 0 },
        { min: 10, max: 20, cnt: 0 },
        { min: 20, max: 30, cnt: 0 },
        { min: 30, max: 40, cnt: 0 },
        { min: 40, max: 50, cnt: 0 },
        { min: 50, max: 75, cnt: 0 },
        { min: 75, max: 100, cnt: 0 },
        { min: 100, max: 99999, cnt: 0 },
      ],
      orderBy: 5,
      sortings: [
        { text: 'Alphabetically A-Z', value: 1 },
        { text: 'Alphabetically Z-A', value: 2 },
        { text: 'Price Low to High', value: 3 },
        { text: 'Price High to Low', value: 4 },
        { text: 'Recently Added', value: 5 },
      ],
      pageSize: this.size ?? 3,
      pageSizes: [
        { text: 'Regular', value: 3 },
        { text: 'Long', value: 9 },
        { text: 'Full', value: 500 },
      ]
    }
  },
  watch: {
    data: { immediate: true, handler() { this.scan() } },
    pageSize: {
      handler() { this.$emit("update:size", this.pageSize) }
    },
  },
  mounted() {
  },
  methods: {
    // ------------------------------------------------------------------------
    scan() {
      this.filters = [{ text: 'Stock Items Only', value: 'stock' }];
      if (Array.isArray(this.data) && this.data.length > 0) {
        this.prices.forEach((e, i) => { e.cnt = 0 });
        this.data.forEach((e) => {
          let idx = this.prices.findIndex((ee) => ee.min <= e.SellingPrice && e.SellingPrice < ee.max);
          if (idx >= 0) {
            this.prices[idx].cnt++;
          }
        });
        this.prices.forEach((e, i) => {
          if (e.cnt > 0) {
            const txt = (e.min == 0 ? 'under ' : '$' + e.min + ' ') +
              (e.min == 0 || e.max == 99999 ? '' : '-') + (e.max == 99999 ? ' and up' : ' $' + e.max);
            this.filters.push({ text: txt, value: i })
          }
        })
        // const highest = this.data.reduce((prev, cur) => (cur.SellingPrice < prev.SellingPrice ? cur : prev));
        // const lowest = this.data.reduce((prev, cur) => (cur.SellingPrice > prev.SellingPrice ? cur : prev));
        this.apply();
      } else {
        this.$emit('input', []);
      }
    },
    // ------------------------------------------------------------------------
    apply() {
      let list = [];
      if (Array.isArray(this.data) && this.data.length > 0) {
        if (this.filterBy.length > 0) {
          this.data.forEach((e) => e.selected = false);
          const inStock = this.filterBy.includes('stock');
          let limited = false;
          this.filterBy.forEach((ft) => {
            if (typeof ft == 'number') {
              limited = true;
              this.data.forEach((e) => {
                if (this.prices[ft].min <= e.SellingPrice && e.SellingPrice < this.prices[ft].max) {
                  e.selected = (inStock ? (e.OnHandQty > 0) : true);
                }
              });
            }
          });
          if (limited) {
            list = this.data.filter((e) => e.selected);
          } else {
            list = this.data.filter((e) => e.OnHandQty > 0);
          }
        } else {
          list = this.data.filter((e) => true);
        }
        // const chk1 = (a) => (a.OnHandQty > 0);
        // const chk2 = (a, b) => (a.OnHandQty > 0 && b.OnHandQty > 0) || (a.OnHandQty <= 0 && b.OnHandQty <= 0);
        const sorting = (a, b, func) => {
          if (a.OnHandQty > 0 && b.OnHandQty > 0) {
            return func(a, b);
          } else if (a.OnHandQty <= 0 && b.OnHandQty <= 0) {
            return (a.NewProduct == 0 && b.NewProduct != 0) ? 1 :
              (a.NewProduct != 0 && b.NewProduct == 0) ? -1 : func(a, b);
          } else if (a.OnHandQty > 0) {
            // return -1;
            return (b.NewProduct == 0) ? -1 : func(a, b);
          } else {
            // return 1;
            return (a.NewProduct == 0) ? 1 : func(a, b);
          }
        };
        if (this.orderBy) switch (this.orderBy) {
          case 1:
            // list.sort((a, b) => a.Title.localeCompare(b.Title));
            // list.sort((a, b) => (chk2(a, b) ? (a.Title.localeCompare(b.Title)) : chk1(a) ? -1 : 1));
            list.sort((a, b) => sorting(a, b, () => (a.Title.localeCompare(b.Title))));
            break;
          case 2:
            // list.sort((a, b) => b.Title.localeCompare(a.Title));
            // list.sort((a, b) => (chk2(a, b) ? (b.Title.localeCompare(a.Title)) : chk1(a) ? -1 : 1));
            list.sort((a, b) => sorting(a, b, () => (b.Title.localeCompare(a.Title))));
            break;
          case 3:
            // list.sort((a, b) => a.SellingPrice - b.SellingPrice);
            // list.sort((a, b) => (chk2(a, b) ? (a.SellingPrice - b.SellingPrice) : chk1(a) ? -1 : 1));
            list.sort((a, b) => sorting(a, b, () => (a.SellingPrice - b.SellingPrice)));
            break;
          case 4:
            // list.sort((a, b) => b.SellingPrice - a.SellingPrice);
            // list.sort((a, b) => (chk2(a, b) ? (b.SellingPrice - a.SellingPrice) : chk1(a) ? -1 : 1));
            list.sort((a, b) => sorting(a, b, () => (b.SellingPrice - a.SellingPrice)));
            break;
          case 5:
            // list.sort((a, b) => (chk2(a, b) ? (a.Id - b.Id) : chk1(a) ? -1 : 1));
            list.sort((a, b) => sorting(a, b, () => (a.Id - b.Id)));
            break;
        }
      }
      // console.log(list.map(e => ({ v: e.SellingPrice, b: (e.OnHandQty > 0) })));
      this.$emit('input', list);
    },
    // ------------------------------------------------------------------------
  },
};
</script>

<template >
  <div class="ma-4 d-flex">
    <v-select class="sort-order" rounded outlined chips v-model="orderBy" :items="sortings" @change="apply" label="Sort by"></v-select>
    <v-select class="list-filter" rounded multiple outlined chips deletable-chips hide-selected menu-props="closeOnClick, closeOnContentClick" v-model="filterBy"
      :items="filters" @change="apply" label="Filters"></v-select>
    <v-select class="page-size" rounded outlined chips v-model="pageSize" :items="pageSizes" label="Page size" v-show="$vuetify.breakpoint.mdAndUp"></v-select>
  </div>
</template>

<style scoped>
.list-filter {
  /* width: fit-content; */
  /* max-width: fit-content; */
  /* max-width: max-content; */
  /* max-width: min-content; */
}

.sort-order {
  max-width: 13.7rem;
}

.page-size {
  max-width: 10rem;
}

/* fit-content; */
</style>